<ng-container *ngIf="locker$ | async as locker">
  <div class="full-width flex justify-between p-3 bg-gray-400 items-center">
    <div>
      <app-main-button (click)="navigateBack()">Zurück</app-main-button>
    </div>
    <div class="flex items-center space-x-3">
      <ng-container *ngIf="!editMode; else editModeButton">
        <app-main-button (click)="switchEditMode()">
          <span nz-icon nzType="edit"></span>
          Bearbeiten
        </app-main-button>
      </ng-container>
      <ng-template #editModeButton>
        <app-main-button (click)="saveLocker()">
          <span nz-icon nzType="save"></span>
          Speichern
        </app-main-button>
      </ng-template>
      <ng-container *ngIf="!editMode; else editModeLockerButton">
        <a nz-dropdown [nzDropdownMenu]="menu">
          <app-main-button type="secondary"
            >Schlüsselaktionen <span nz-icon nzType="down"></span
          ></app-main-button>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <ng-container *ngIf="locker.zugewiesenAn === null; else freigeben">
              <li nz-menu-item (click)="onAssignClick()">
                <span nz-icon nzType="user-add"></span>
                Zuweisen
              </li>
            </ng-container>
            <ng-template #freigeben>
              <ng-container
                *ngIf="
                  !locker.zweitschluesselAusgegebenAm;
                  else zweitSchluessel
                "
              >
                <li nz-menu-item (click)="onLockerReleaseClick()">
                  <span nz-icon nzType="key"></span> Schlüsselrücknahme
                </li>
              </ng-container>
              <ng-template #zweitSchluessel>
                <li nz-menu-item (click)="onSecondKeyWithdrawalClick()">
                  <span nz-icon nzType="key"></span> 2. Schlüsselrücknahme
                </li>
              </ng-template>
            </ng-template>
            <ng-container
              *ngIf="
                locker.zugewiesenAn &&
                locker.zweitschluesselAusgegebenAm === null
              "
            >
              <li nz-menu-item (click)="onHandoutSecondKey()">
                <span nz-icon nzType="key"></span> 2. Schlüsselausgabe
              </li>
            </ng-container>
            <li nz-menu-item nzDanger (click)="onReplaceLockClick()">
              <span nz-icon nzType="key" nzTheme="outline"></span>
              Schloss ersetzen
            </li>
          </ul>
        </nz-dropdown-menu>
      </ng-container>

      <ng-template #editModeLockerButton>
        <app-main-button type="danger" (click)="deleteLocker()">
          <span nz-icon nzType="delete"></span>
          Löschen
        </app-main-button>
        <app-main-button type="danger" (click)="switchEditMode()">
          <span nz-icon nzType="close" nzTheme="outline"></span>
          Abbrechen
        </app-main-button>
      </ng-template>
    </div>
  </div>
</ng-container>

<div class="p-6 bg-white">
  <ng-container *ngIf="locker$ | async as locker; else loading">
    <div class="flex justify-between w-full pb-20">
      <div class="text-3xl text-blue-900">Spindinformationen</div>
    </div>

    <ng-container>
      <form [formGroup]="validateLockerForm">
        <div
          class="pb-5 grid grid-cols-12 grid-rows-3 gap-5"
          [ngClass]="{ 'readonly-select': !editMode }"
        >
          <app-form-input
            label="Bezeichnung"
            attribute="bezeichnung"
            [readOnly]="!editMode"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>

          <app-form-select
            label="Größe"
            attribute="spindart"
            [selectOptions]="selectSizes"
            [readOnly]="!editMode"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Standort"
            attribute="standort"
            [selectOptions]="selectLocation"
            [readOnly]="!editMode"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Räumlichkeiten"
            attribute="geschlecht"
            [selectOptions]="selectGender"
            [readOnly]="!editMode"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <app-form-select
            label="Status"
            attribute="status"
            [selectOptions]="allowedStatusOptions"
            [readOnly]="!editMode || locker.status === 'Belegt'"
            valueKey="valueKey"
            labelKey="labelKey"
            subformGroup="mandatoryFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          >
          </app-form-select>

          <ng-container *ngIf="locker.status === 'Belegt'">
            <app-form-input
              subformGroup="optionalFields"
              [readOnly]="true"
              attribute="person"
              label="Person"
              class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            ></app-form-input>
          </ng-container>
          <ng-container
            *ngIf="
              validateLockerForm.get('mandatoryFields.status')?.value === 3
            "
          >
            <app-form-select
              label="Sperrgrund"
              attribute="sperrgrund"
              [selectOptions]="selectReasonForBlock"
              [readOnly]="!editMode"
              valueKey="valueKey"
              labelKey="labelKey"
              subformGroup="optionalFields"
              class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            ></app-form-select>
          </ng-container>
        </div>
        <div
          class="grid grid-cols-12 gap-5"
          [ngClass]="{ 'readonly-select': !editMode }"
        >
          <app-form-textarea
            label="Bemerkung"
            attribute="bemerkung"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
            placeholder="Schreiben Sie hier einen Kommentar"
          ></app-form-textarea>
        </div>
      </form>
      <ng-container *ngIf="lockerHistory.length > 0">
        <div class="pr-10 mt-10">
          <nz-collapse nzGhost>
            <nz-collapse-panel [nzHeader]="historyHeader">
              <div class="pt-10 h-96 overflow-y-auto overflow-x-hidden">
                <nz-timeline nzMode="alternate">
                  @for (event of lockerHistory; track $index) {
                    <nz-timeline-item
                      [nzColor]="setHistoryColor(event.beschreibung)"
                    >
                      <p>Am {{ formatDate(event.datum) }}</p>
                      <p>
                        {{ event.beschreibung }}
                      </p>
                      <ng-container *ngIf="event.spindperson">
                        <p>
                          Betroffene Person:
                          {{ event.spindperson?.vorname }}
                          {{ event.spindperson?.name }}
                        </p>
                      </ng-container>
                    </nz-timeline-item>
                  }
                </nz-timeline>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
          <ng-template #historyHeader>
            <p class="text-2xl text-blue-900">Spindhistorie</p>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="grid grid-cols-1 space-y-4">
      <p class="flex justify-center text-gray-600">
        Lade Spindinformationen...
      </p>
      <nz-spin class="flex justify-center" nzSimple></nz-spin>
    </div>
  </ng-template>
</div>

<nz-modal
  [nzFooter]="modalFooter"
  [(nzVisible)]="modalIsVisible"
  nzTitle="Spindzuweisung"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <p class="pb-5 text-lg font-medium">Person zum Zuweisen auswählen</p>

    <div class="grid grid-cols-1 gap-5 pb-5">
      <div class="relative">
        <nz-input-group nzSize="large" [nzPrefix]="prefixTemplateUser">
          <input
            placeholder="Hier Name eingeben"
            nz-input
            [(ngModel)]="searchTerm"
            [nzAutocomplete]="auto"
            (input)="onInput()"
            class="w-full"
          />
          <nz-autocomplete #auto>
            <nz-auto-option
              *ngFor="let person of searchedPersons$ | async"
              [nzValue]="person.id"
              [nzLabel]="person.vorname + ' ' + person.name"
            >
              <div class="flex justify-between items-center w-full">
                <span>{{ person.vorname }} {{ person.name }}</span>
                <span class="text-gray-500 text-sm">
                  (Gruppe: {{ getPersonGroup(person) }})
                </span>
              </div>
            </nz-auto-option>
          </nz-autocomplete>
        </nz-input-group>

        <nz-spin
          *ngIf="isLoading"
          nzSimple
          class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10"
        ></nz-spin>

        <ng-template #prefixTemplateUser>
          <span nz-icon nzType="user"></span>
        </ng-template>
      </div>

      <div>
        <nz-range-picker
          class="w-full"
          nzSize="large"
          nzFormat="dd/MM/yyyy"
          [(ngModel)]="date"
        ></nz-range-picker>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #modalFooter>
  <div class="flex justify-end">
    <app-main-button (click)="handleOk()">Spind zuweisen</app-main-button>
    <app-main-button type="danger" (click)="handleCancel()"
      >Abbrechen
    </app-main-button>
  </div>
</ng-template>
